// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/ico/font-awesome.css
// module id = Yaid
// module chunks = 88